import { cn } from "@/lib/utils";

interface CostDisclaimerProps {
  className?: string;
}

export default function CostDisclaimer({ className }: CostDisclaimerProps) {
  return (
    <div className={cn("flex items-start gap-2 text-xs text-gray-600 dark:text-gray-400", className)}>
      <span className="text-base leading-none">ℹ️</span>
      <span>
        Cost estimate based on average 30-minute episodes (about 2 cents per episode). Actual cost may vary.
      </span>
    </div>
  );
}

